import apiFetch from '@wordpress/api-fetch';
import { Appointment } from '../models/appointment';
import dayjs from 'dayjs';

export async function sendAppointmentRequest(appointment: Appointment): Promise<any> {
	return apiFetch({
		path: '/bookr/v1/save-appointment',
		method: 'POST',
		data: appointment,
	});
}

export async function getReservedAppointments(): Promise<Appointment[]> {
	const response: any[] = await apiFetch({
		path: '/bookr/v1/reserved-appointments',
		method: 'GET',
	});

	const appointments: Appointment[] = response.map((res) => {
		return {
			startTime: res.start_time,
			status: res.status,
		};
	});

	return appointments;
}

export async function getAllAppointsmentsWithCustomer(start: Date, end: Date): Promise<Appointment[]> {
	try {
		const startString = dayjs(start).format('YYYY-MM-DD');
		const endString = dayjs(end).format('YYYY-MM-DD');

		const response: any[] = await apiFetch({
			path: `/bookr/v1/appointments?start=${startString}&end=${endString}`,
			method: 'GET',
		});

		const appointments: Appointment[] = response.map((res) => {
			return {
				id: res.id,
				status: res.status,
				startTime: res.start_time,
				notes: res.notes,
				customer: {
					id: res.customer_id,
					firstname: res.firstname,
					lastname: res.lastname,
					email: res.email,
					phoneNumber: res.phone_number,
				},
			};
		});

		return appointments;
	} catch (error) {
		return [];
	}
}

export function updateAppointment(appointment: Appointment) {
	apiFetch({
		path: '/bookr/v1/update-appointment',
		method: 'POST',
		data: appointment,
	});
}

export async function deleteAppointment(id: number): Promise<void> {
	await apiFetch({
		path: `/bookr/v1/appointment?id=${id}`,
		method: 'DELETE',
	});
}
